import React from 'react'

export default function LeftIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 17L10 12L15 7" stroke="#767676" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}
